import { render } from "./ExchangeCard.vue?vue&type=template&id=08b2492a&scoped=true"
import script from "./ExchangeCard.vue?vue&type=script&lang=js"
export * from "./ExchangeCard.vue?vue&type=script&lang=js"

import "./ExchangeCard.vue?vue&type=style&index=0&id=08b2492a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b2492a"]])

export default __exports__